/** @format */
import { css } from 'styled-components';

import { StyledIconListItemProps } from './types';

const baseStyles = ({ isTransparent }: StyledIconListItemProps) => css`
    list-style-type: none;
    margin-bottom: 1.2rem;
    display: flex;
    opacity: ${isTransparent ? 0.6 : 1};
    gap: var(--layout-spacing-12);
    align-items: center;

    .icon {
        display: flex;
        align-items: center;
    }

    .content {
        flex-grow: 1;
    }
`;

export const styles = (props: StyledIconListItemProps) => css`
    ${baseStyles(props)}
`;
